import React from "react";

export const SearchBarDesktop = ({ onChangeCode }) => {
  const onChangeData = (e) => {
    onChangeCode(e.target.value);
    //alert(e.target.value);
  };
  const handleKeyDown = () => {
    return;
  };

  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-25">
          <input
            type="email"
            className="form-control input-sm"
            placeholder="Tên, SĐT, CCCD khách hàng"
            onChange={onChangeData}
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="input-sm-new input-new-18 search-main-new">
          <button type="submit" className="btn btn-info-new">
            <i className="la la-search"></i>
          </button>
        </div>
      </div>

      <div className="iconbutton-new hidden-mobile-main show-table-main">
        <div className="row">
          <div className="col-md-12">
            <h4 className="form-section">
              Kiểm tra khách hàng có vay ở cửa hàng khác trong hệ thống hay
              không
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};
